export const formatEuro = (amount) => {
  const formatted = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
  
  // Reemplazar el símbolo € de posición alemana al final
  return formatted.replace(/\s?€/, ' €').trim();
};

export const formatNumber = (number) => {
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(number);
};

export const formatPercentage = (percentage) => {
  return `${percentage.toFixed(2)}%`;
};
